import { GET_TAGS } from 'actions/Types';

export default (state = [], action) => {
  if (action.type === `${GET_TAGS}_SUCCESS`) {
    return action.payload;
  }

  return state;
};
